module.exports = __webpack_public_path__ + "img/mul.3926c568.png";